import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_column_chart extends vnTemplate{

    protected buildViewModel(): any {
        let _this = this;
        return  {
            idChart: ko.observable("chartDiv_" + _this.idElement),
            category: ko.observable(""),
            cssWidth: ko.observable("100%"),
            cssHeight: ko.observable("300px"),
            xAxisRotation: ko.observable(0),
            xAxisFontSize: ko.observable(8),
            seriesTooltipFormat: ko.observable("{name}: [bold]{valueY}[/]"),
            show: ko.observable(true),
            yaxis: ko.observableArray([]),
            ranges: ko.observableArray([]),
        };
    }

    protected getMainElementClasses(): Array<string>{
        return ["graph"];
    }

    protected getTemplateHtml(): string {
        return `<div data-bind="attr: {id: idChart}, style: {width: cssWidth, height: cssHeight, display: (show() == true) ? 'block': 'none' }"></div>`;
    }

    protected getTemplateName(): string {
        return "amCharts_v4_column_chart";
    }

    public setXAxisRotation(rotation: number): void {
        this.getTemplateViewModel().xAxisRotation(rotation);
    }


    public setXAxisFontSize(rotation: number): void {
        this.getTemplateViewModel().xAxisFontSize(rotation);
    }

    public setSeriesTooltipFormat(tooltipFormat: string): void {
        this.getTemplateViewModel().seriesTooltipFormat(tooltipFormat);
    }

    public setCategory(category) {
        this.getTemplateViewModel().category(category);
    }

    public setYaxis(axis) {
        this.getTemplateViewModel().yaxis(axis);
    }

    public setRanges(ranges) {
        this.getTemplateViewModel().ranges(ranges);
    }

    public show(): void {
        this.getTemplateViewModel().show(true);
    }

    public hide(): void {
        this.getTemplateViewModel().show(false);
    }

    public drawChart(chartData) {
        let _this = this;
        am4core.useTheme(am4themes_animated);

        // Themes end
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        chart.data = chartData;

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = chartData.category;
        // categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.verticalCenter = "top"
        categoryAxis.renderer.labels.template.rotation = chartData.rotate;
        categoryAxis.renderer.labels.template.horizontalCenter = chartData.horizontalCenter;
        categoryAxis.renderer.labels.template.verticalCenter = chartData.verticalCenter;
        categoryAxis.renderer.labels.template.disabled = false;
        categoryAxis.renderer.grid.template.disabled = false;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.grid.template.disabled = false;
        if (chartData.hasOwnProperty('minimalValue')) {

            valueAxis.min = chartData.minimalValue;
        }

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = chartData.yAxis;
        series.dataFields.categoryX = chartData.xAxis;
        series.name = chartData.name;
        series.columns.template.tooltipText = this.getTemplateViewModel().seriesTooltipFormat();
        //series.columns.template.fillOpacity = .8;
        series.stacked = chartData.isStacked;
        series.columns.template.tooltipText = "New Articles: {valueY}";
        series.fill = am4core.color(chartData.series1Fill);

        if(chartData.isStacked){
                let series2 = chart.series.push(new am4charts.ColumnSeries());
                series2.dataFields.valueY = "count2";
                series2.dataFields.categoryX = "category";
                //series2.name = "Republishes";
                series2.columns.template.tooltipText = this.getTemplateViewModel().seriesTooltipFormat();
                //series2.columns.template.fillOpacity = .8;
                series2.columns.template.tooltipText = "Republishes: {count2}";
                series2.stacked = true;
                series2.fill = am4core.color(chartData.series2Fill);
                series2.columns.template.fill = am4core.color(chartData.series2Fill);

        }

        // let columnTemplate = series.columns.template;
        // columnTemplate.strokeWidth = 2;
        // columnTemplate.strokeOpacity = 1;
        series.columns.template.fill = am4core.color(chartData.series1Fill);
        series.columns.template.column.propertyFields.fill = "color";

        chart.logo.disabled = true;

    }

    public drawChartContentValueReporting(chartData) {
        let _this = this;
        am4core.useTheme(am4themes_animated);
    
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);
        chart.data = chartData;
    
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = chartData.rotate;
        categoryAxis.renderer.labels.template.horizontalCenter = chartData.horizontalCenter;
        categoryAxis.renderer.labels.template.verticalCenter = chartData.verticalCenter;
    
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Published Articles Count";
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.grid.template.disabled = false;
    
        const createSeries = (field, name, color) => {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "category";
            series.name = name;
            series.columns.template.tooltipText = `${name}: {valueY}`;
            series.fill = am4core.color(color);
            series.stroke = am4core.color(color);
        };
    
        createSeries("red", "Red Badge", "#ff0000");
        createSeries("orange", "Orange Badge", "#f0932b");
        createSeries("silver", "Silver Badge", "#95afc0");
        createSeries("gold", "Gold Badge", "#ffd32a");
    
        chart.logo.disabled = true;
    }

    public drawChartContentValueEngagementReporting(chartData) {
        let _this = this;
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);
        chart.data = chartData;

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";  
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.title.text = "Badge";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Average Time on Page (Seconds)";
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.grid.template.disabled = false;

        const createSeries = (field, name) => {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "category";  
            series.name = name;
            series.columns.template.tooltipText = `${name}: {valueY.formatNumber("#.00")} seconds`;

            // Assign colors based on the category (badge) value
            series.columns.template.adapter.add("fill", function(fill, target) {
                const dataItem = target.dataItem as am4charts.ColumnSeriesDataItem;
                if (dataItem && dataItem.categoryX) {
                    switch (dataItem.categoryX) {
                        case "red":
                            return am4core.color("#ff0000");
                        case "orange":
                            return am4core.color("#f0932b");
                        case "silver":
                            return am4core.color("#95afc0");
                        case "gold":
                            return am4core.color("#ffd32a");
                        default:
                            return fill;
                    }
                }
                return fill;
            });

            series.columns.template.adapter.add("stroke", function(stroke, target) {
                return target.fill;
            });
        };

        createSeries("avgTimeOnPage", "Average Time on Page");

        chart.logo.disabled = true;
    }

    public drawColumnChart(chartData): void {
        let _this = this;
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartDiv_" + _this.idElement , am4charts.XYChart);
    
        // Add data
        chart.data = chartData;
    
        // Create category axis for the X-axis
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.title.text = "Category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
    
        // Create value axis for the Y-axis
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Average Time on Page (Seconds)";
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.grid.template.disabled = false;
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "count";
        series.dataFields.categoryX = "category";
        series.name = "Average Time on Page";
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/] s";
        series.columns.template.fill = am4core.color("#104547"); // Default color
        series.columns.template.propertyFields.fill = "color";  // Use data-provided color
    
        // Disable the amCharts logo
        chart.logo.disabled = true;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_column_chart.ts